import React, { useEffect, useState } from 'react'
import { useAuth } from '../../context/auth-context';
import axios from 'axios';
import { toast } from 'react-toastify';
import { rootUrl } from '../../helpers';
import DataTable from 'react-data-table-component';
import { 
  FaSpinner, 
  FaThumbsUp, 
  FaUsers, 
  FaEnvelope, 
  FaPhone, 
  FaCalendar, 
  FaVenusMars, 
  FaCheckCircle, 
  FaClock,
  FaUserShield,
  FaBuilding,
  FaFileAlt,
  FaEllipsisV,
  FaUserTag,
  FaClipboardCheck
} from 'react-icons/fa';
import FormGenerator from '../../components/formGenerator';
import Modal from '../../components/Modal';

export default function Users() {

   const auth = useAuth()

   const [users, setUsers] = useState([]);
   const [roles, setRoles] = useState([]);
   const [banks, setBanks] = useState([]);
   const [reports, setReports] = useState([]);
   const [approvalRoles, setApprovalRoles] = useState([]);
  const [menuState, setMenuState] = useState({
    id: null,
    top: 0,
    left: 0,
    openUp: false,
  });
   

    const fetchData = async () => {
        try {
          const data = await axios.get(rootUrl(`/getUsers/${auth.user.cid}`));
          if (data.status === 200) {
            setUsers(data.data.data.biodata);
            
          }
        } catch (e) {
          toast.error(e?.message);
        }

        try {
          const data = await axios.get(rootUrl(`/getRoles`));
          if (data.status === 200) {
            setRoles(data.data.data);
          }
        } catch (e) {
          toast.error(e?.message);
        }

        try {
          const data = await axios.get(rootUrl(`/getBanks/${auth.user.cid}`));
          if (data.status === 200) {
            setBanks(data.data.data);
          }
        } catch (e) {
          toast.error(e?.message);
        }

        try {
          const data = await axios.get(rootUrl(`/getReports`));
          if (data.status === 200) {
            setReports(data.data.data);
          }
        } catch (e) {
          toast.error(e?.message);
        }

        try {
          const data = await axios.get(rootUrl(`/getApprovalRoles`));
          if (data.status === 200) {
            setApprovalRoles(data.data.data || []);
          }
        } catch (e) {
          toast.error(e?.message);
        }
      };
    
      useEffect(()=>{
        fetchData()
      }, [])

      const [modal, setModal] = useState({title: '', open: false, body: '', size: 'sm'});
      const closeMenu = () => {
        setMenuState((prev) => ({ ...prev, id: null }));
      };
        
      const handleClose = () => {
        setModal({...modal, open: false });   
      };
    
      const columns = [
        { 
          name: 'Email', 
          selector: row => row.email, 
          sortable: true,
          cell: row => (
            <div className="flex items-center gap-2 py-2">
              <FaEnvelope className="text-gray-400 text-sm" />
              <span className="text-gray-700">{row.email}</span>
            </div>
          )
        },
        { 
          name: 'Full Name', 
          selector: row => row.firstname +' '+row.lastname, 
          sortable: true,
          cell: row => (
            <div className="flex items-center gap-2 py-2">
              <FaUsers className="text-gray-400 text-sm" />
              <span className="font-medium text-gray-900">{row.firstname} {row.lastname}</span>
            </div>
          )
        },
        { 
          name: 'Phone Number', 
          selector: row => row.phonenumber, 
          sortable: true,
          cell: row => (
            <div className="flex items-center gap-2 py-2">
              <FaPhone className="text-gray-400 text-sm" />
              <span className="text-gray-700">{row.phonenumber}</span>
            </div>
          )
        },
        { 
          name: 'Date of Birth', 
          selector: row => row.dob, 
          sortable: true,
          cell: row => (
            <div className="flex items-center gap-2 py-2">
              <FaCalendar className="text-gray-400 text-sm" />
              <span className="text-gray-700">{row.dob}</span>
            </div>
          )
        },
        { 
          name: 'Gender', 
          selector: row => row.sex, 
          sortable: true,
          cell: row => (
            <div className="flex items-center gap-2 py-2">
              <FaVenusMars className="text-gray-400 text-sm" />
              <span className="text-gray-700 capitalize">{row.sex}</span>
            </div>
          )
        },
        { 
          name: 'Status', 
          cell: row => (
            <div className="py-2">
              {row.mode == 0 ? (
                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                  <FaClock className="text-xs" />
                  Pending
                </span>
              ) : (
                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  <FaCheckCircle className="text-xs" />
                  Approved
                </span>
              )}
            </div>
          )
        },
        {
          name: 'Actions',
          width: '120px',
          cell: row => (
            <div className="relative py-2">
              {row.mode == 0 ? (
                <button 
                  className="p-2 bg-green-100 hover:bg-green-200 text-green-700 rounded-lg transition-colors" 
                  onClick={() => handleApprove(row.auth_id ?? row.u_id)}
                  title="Approve user registration"
                > 
                  <FaThumbsUp className="text-sm" /> 
                </button>
              ) : (
                <div className="relative inline-block text-left">
                  <button
                    type="button"
                    className="p-2 bg-slate-100 hover:bg-slate-200 text-slate-800 rounded-lg border border-slate-200"
                    title="User actions"
                    onClick={(e) => {
                      e.stopPropagation();
                      const rect = e.currentTarget.getBoundingClientRect();
                      const menuEstimatedHeight = 260;
                      const spaceBelow = window.innerHeight - rect.bottom;
                      const shouldOpenUp = spaceBelow < menuEstimatedHeight && rect.top > menuEstimatedHeight;

                      const userKey = row.auth_id ?? row.u_id;

                      setMenuState((prev) => {
                        if (prev.id === userKey) {
                          return { ...prev, id: null };
                        }
                        return {
                          id: userKey,
                          top: shouldOpenUp ? rect.top - 6 : rect.bottom + 6,
                          left: rect.right,
                          openUp: shouldOpenUp,
                        };
                      });
                    }}
                  >
                    <FaEllipsisV className="text-sm" />
                  </button>
                  {menuState.id === (row.auth_id ?? row.u_id) && (
                    <>
                      <div
                        className="fixed inset-0 z-40"
                        aria-hidden="true"
                        onClick={closeMenu}
                      />
                      <div
                        className="fixed z-50 w-56 rounded-lg border border-gray-200 bg-white py-1 text-sm shadow-lg"
                        style={{
                          top: `${menuState.top}px`,
                          left: `${menuState.left}px`,
                          transform: menuState.openUp ? 'translate(-100%, -100%)' : 'translateX(-100%)',
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-gray-500">
                          Access &amp; data
                        </div>
                        <button
                          type="button"
                          className="flex w-full items-center gap-2 px-3 py-2 text-left hover:bg-gray-50"
                          onClick={() => { closeMenu(); handleRoles(row.auth_id ?? row.u_id, 1); }}
                        >
                          <FaUserShield className="text-green-700" /> Navigation (sidebar)
                        </button>
                        <button
                          type="button"
                          className="flex w-full items-center gap-2 px-3 py-2 text-left hover:bg-gray-50"
                          onClick={() => { closeMenu(); handleRoles(row.auth_id ?? row.u_id, 2); }}
                        >
                          <FaBuilding className="text-blue-700" /> Bank access
                        </button>
                        <button
                          type="button"
                          className="flex w-full items-center gap-2 px-3 py-2 text-left hover:bg-gray-50"
                          onClick={() => { closeMenu(); handleRoles(row.auth_id ?? row.u_id, 3); }}
                        >
                          <FaFileAlt className="text-purple-700" /> Reports
                        </button>
                        <button
                          type="button"
                          className="flex w-full items-center gap-2 px-3 py-2 text-left hover:bg-gray-50"
                          onClick={() => { closeMenu(); handleRoles(row.auth_id ?? row.u_id, 4); }}
                        >
                          <FaClipboardCheck className="text-amber-700" /> Payment approvals
                        </button>
                        <hr className="my-1" />
                        <button
                          type="button"
                          className="flex w-full items-center gap-2 px-3 py-2 text-left hover:bg-gray-50"
                          onClick={() => { closeMenu(); openPositionModal(row); }}
                        >
                          <FaUserTag className="text-indigo-700" /> Position / designation
                        </button>
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          ),
          button: true
        }
      ];
      const handleApprove = async (id) => {
        try {
            const data = await axios.get(rootUrl(`/approve/${id}`));
            if (data.status === 200) {
                toast.success("Successful");
                fetchData()
            }
          } catch (e) {
            toast.error(e?.message);
          }
      };

      const onsubmit = async (formdata) => {
        formdata['giver'] = auth.user.id;
        const t = formdata.roleType;
        const urls = {
          1: 'giveUserRoles',
          2: 'giveBankUserRoles',
          3: 'giveUserReportRoles',
          4: 'giveUserApprovalRoles',
        };
        const url = urls[t];
        if (!url) return;
        try {
          const data = await axios.post(rootUrl(`/${url}`), formdata);
          if (data.status === 200) {
            toast.success("Successful");
            fetchData();
            handleClose();
          }
        } catch (e) {
          toast.error(e?.message);
        }
      };

      function handleRoles(id, typ) {
        const titles = {
          1: 'Navigation (sidebar)',
          2: 'Bank access',
          3: 'Reports',
          4: 'Payment approval roles',
        };
        const rolesList =
          typ === 1 ? roles : typ === 2 ? banks : typ === 3 ? reports : approvalRoles;
        setModal({
          title: titles[typ] || 'Roles',
          open: true,
          size: 'sm',
          body: (
            <RoleSelectionForm
              roles={rolesList}
              uid={id}
              type={typ}
              onSubmit={onsubmit}
              onClose={handleClose}
            />
          ),
        });
      }

      const openPositionModal = (row) => {
        setModal({
          title: 'Position / designation',
          open: true,
          size: 'sm',
          body: (
            <PositionForm
              initialPosition={row.position || ''}
              onSubmit={async (position) => {
                try {
                  const data = await axios.post(rootUrl('/updateUserPosition'), {
                    uid: row.auth_id ?? row.u_id,
                    position,
                    giver: auth.user.id,
                  });
                  if (data.status === 200) {
                    toast.success('Saved');
                    fetchData();
                    handleClose();
                  }
                } catch (e) {
                  toast.error(e?.message);
                }
              }}
              onClose={handleClose}
            />
          ),
        });
      };

     
  
  const customStyles = {
    headRow: {
      style: {
        backgroundColor: '#1e3a8a',
        color: '#ffffff',
        fontSize: '14px',
        fontWeight: '600',
        textTransform: 'uppercase',
        borderTopLeftRadius: '12px',
        borderTopRightRadius: '12px',
      },
    },
    headCells: {
      style: {
        paddingLeft: '16px',
        paddingRight: '16px',
        paddingTop: '16px',
        paddingBottom: '16px',
      },
    },
    cells: {
      style: {
        paddingLeft: '16px',
        paddingRight: '16px',
        paddingTop: '12px',
        paddingBottom: '12px',
        fontSize: '14px',
      },
    },
    rows: {
      style: {
        borderBottom: '1px solid #e5e7eb',
        '&:hover': {
          backgroundColor: '#f9fafb',
        },
      },
    },
    pagination: {
      style: {
        borderTop: '1px solid #e5e7eb',
        paddingTop: '16px',
        paddingBottom: '16px',
      },
    },
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-950 to-blue-800 rounded-2xl p-6 text-white shadow-lg">
        <div className="flex items-center gap-4">
          <div className="bg-white/20 rounded-xl p-3">
            <FaUsers className="text-2xl" />
          </div>
          <div>
            <h1 className="text-2xl md:text-3xl font-bold">User Management</h1>
            <p className="text-blue-100 text-sm mt-1">Manage users, roles, and permissions</p>
          </div>
        </div>
      </div>

      {/* User Table */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-visible">
        <DataTable
          columns={columns}
          data={users}
          pagination
          highlightOnHover
          pointerOnHover
          customStyles={customStyles}
          noDataComponent={
            <div className="py-12 text-center">
              <FaUsers className="text-gray-400 text-5xl mx-auto mb-4" />
              <p className="text-gray-600 font-medium">No users found</p>
              <p className="text-gray-500 text-sm mt-2">Users will appear here once they register</p>
            </div>
          }
          progressComponent={
            <div className="py-12 text-center">
              <FaSpinner className="animate-spin text-blue-950 text-5xl mx-auto mb-4" />
              <p className="text-gray-600 font-medium">Loading users...</p>
            </div>
          }
        />
      </div>

      {modal.open && (
        <Modal title={modal.title} onClose={handleClose}>
          {modal.body}
        </Modal>
      )}
    </div>
  )
}

function PositionForm({ initialPosition, onSubmit, onClose }) {
  const [position, setPosition] = useState(initialPosition || '');
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(position);
      }}
      className="space-y-4"
    >
      <p className="text-sm text-gray-600">
        This text appears on payment vouchers as the signer designation line.
      </p>
      <input
        type="text"
        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
        value={position}
        onChange={(e) => setPosition(e.target.value)}
        placeholder="e.g. Principal Accountant"
      />
      <div className="flex justify-end gap-2 pt-2">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 text-sm font-medium"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 bg-blue-950 text-white rounded-lg hover:bg-blue-900 text-sm font-medium"
        >
          Save
        </button>
      </div>
    </form>
  );
}

const RoleSelectionForm = ({ roles, uid, onSubmit, type, onClose }) => {
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  const getUserRoles = async () => {
    try {
      let url = '';
      if (type === 1) {
        url = 'getUserRoles';
      } else if (type === 2) {
        url = 'getUserBankRoles';
      } else if (type === 3) {
        url = 'getUserReportRoles';
      } else if (type === 4) {
        url = 'getUserApprovalRoles';
      }
      if (!url) {
        setLoading(false);
        return;
      }
      const response = await axios.get(rootUrl(`/${url}/${uid}`));
      const rows = response.data.data || [];
      if (type === 1) {
        setSelectedRoles(rows.map((a) => a.nid));
      } else if (type === 2) {
        setSelectedRoles(rows.map((a) => a.bid));
      } else if (type === 3) {
        setSelectedRoles(rows.map((a) => a.rid));
      } else if (type === 4) {
        setSelectedRoles(rows.map((a) => a.rid));
      }
    } catch (error) {
      console.error("Error fetching user roles:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getUserRoles();
  }, [uid, type]);

  const handleRoleChange = (roleId) => {
    setSelectedRoles((prevRoles) =>
      prevRoles.includes(roleId)
        ? prevRoles.filter((id) => id !== roleId) 
        : [...prevRoles, roleId] 
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ uid, roles: selectedRoles, roleType: type });
  };

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <FaSpinner className="animate-spin text-blue-950 text-5xl mb-4" />
        <p className="text-gray-600 font-medium">Loading roles...</p>
      </div>
    );
  }

  let title = ''
  let icon = null
  let colorClass = ''
  if (type === 1) {
    title = 'Select Navigation Roles'
    icon = <FaUserShield className="text-xl" />
    colorClass = 'from-green-500 to-green-600'
  } else if (type === 2) {
    title = 'Select Bank Roles'
    icon = <FaBuilding className="text-xl" />
    colorClass = 'from-blue-500 to-blue-600'
  } else if (type === 3) {
    title = 'Select Report Roles'
    icon = <FaFileAlt className="text-xl" />
    colorClass = 'from-purple-500 to-purple-600'
  } else if (type === 4) {
    title = 'Payment approval roles'
    icon = <FaClipboardCheck className="text-xl" />
    colorClass = 'from-amber-500 to-amber-600'
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Header */}
      <div className={`bg-gradient-to-r ${colorClass} rounded-xl p-4 text-white`}>
        <div className="flex items-center gap-3">
          <div className="bg-white/20 rounded-lg p-2">
            {icon}
          </div>
          <div>
            <h2 className="text-lg font-bold">{title}</h2>
            <p className="text-sm text-white/90 mt-0.5">Select the roles to assign to this user</p>
          </div>
        </div>
      </div>

      {/* Role Selection */}
      <div className="max-h-96 overflow-y-auto space-y-3 pr-2">
        {roles.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <p>No roles available</p>
          </div>
        ) : (
          roles.map((role) => (
            <label 
              key={role.id} 
              className={`
                flex items-center gap-3 p-4 rounded-lg border-2 cursor-pointer transition-all
                ${selectedRoles.includes(role.id) 
                  ? 'border-blue-500 bg-blue-50' 
                  : 'border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50'
                }
              `}
            >
              <input
                type="checkbox"
                value={role.id}
                checked={selectedRoles.includes(role.id)}
                onChange={() => handleRoleChange(role.id)}
                className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
              />
              <span className={`flex-1 font-medium ${selectedRoles.includes(role.id) ? 'text-blue-900' : 'text-gray-700'}`}>
                {type === 3 ? role.description : type === 4 ? `${role.name}${Number(role.hierarchy) >= 0 ? ` (step ${Number(role.hierarchy) + 1})` : ""}` : role.name}
              </span>
              {selectedRoles.includes(role.id) && (
                <FaCheckCircle className="text-blue-600 text-lg" />
              )}
            </label>
          ))
        )}
      </div>

      {/* Submit Button */}
      <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
        <button
          type="button"
          onClick={onClose}
          className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
        >
          Cancel
        </button>
        <button
          type="submit"
          className={`px-6 py-2.5 bg-gradient-to-r ${colorClass} text-white rounded-lg hover:shadow-lg transition-all font-medium flex items-center gap-2`}
        >
          <FaCheckCircle />
          <span>Save Changes</span>
        </button>
      </div>
    </form>
  );
};



